import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-sm font-mono text-slate-500">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
